import { render, staticRenderFns } from "./media-block-edit.vue?vue&type=template&id=0376aabd&"
import script from "./media-block-edit.vue?vue&type=script&lang=js&"
export * from "./media-block-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports